import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import { useFeatureFlagCookieContext } from '@usap/core'

export default function PartNo(props) {
  const { sku } = props
  const { fullTitleCookie: showFullTitle } = useFeatureFlagCookieContext()

  return (
    <Box width="100%">
      <Text size="xsmall" color={showFullTitle ? '#686868' :'dark-2'}>
        {`Part Number: ${sku}`}
      </Text>
    </Box>

  )
}
